import styled, { css } from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import { media } from '../../../utils/styles'

const FormRow = styled.div`
  ${ifProp('leader', css`margin-top: 1em;`)};
  ${ifProp('tralier', css`margin-bottom: 1em;`)};
  ${media('tablet')`
    margin-left: -1.5em;
    margin-right: -1.5em;
  `}
`

export default FormRow
